<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div style="margin:0 auto; text-align: center;">
		<div class="matTitulo">
			<i class="fas fa-video" id="ico"></i>
			<h1 class="titulo" style="display:inline-block;">Videos</h1>
		</div>
	</div>
</div>
<mat-card class="mt-3">
	<iframe class="video" id="myIframe" [src]="link | safeUrl"></iframe>
</mat-card>
<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>
